<script lang="ts">
    import { MatrixIcon } from "@anyways-open/common-svgs";
    import { get } from "svelte/store";
    import { appManager } from "../../../../../AppManager";
    import type { MatrixRowManager } from "./MatrixRowManager";
    import MatrixAssignmentRow from "./assignments/MatrixAssignmentRow.svelte";

    export let manager: MatrixRowManager;

    let visible = manager.visible;
    let active = manager.active;
    let matrix = manager.matrix;
    let assignmentRows = manager.getMatrixAssignmentRows();

    let matrixName = get(manager.matrix.name);

    $: {
        matrix = manager.matrix;
        assignmentRows = manager.getMatrixAssignmentRows();
        updateName();
    }

    function updateName() {
        matrixName = get(manager.matrix.name);
    }

    function onSaveMatrix(): void {
        // TODO: is this still needed with store approach?
        matrix.name.set(matrixName);
    }

    const onEditAsync = async () => {
        await manager.onEditMatrixClick();
    };

    const remove = () => {
        manager.delete();
    };

    const onCopyAsync = async () => {
        const result = await appManager.ModalHooks.OdCopyModal.open(matrix.getData());
        if (result === "copy") {
            await manager.copy();
        } else if (result === "transpose") {
            await manager.copyAndTranspose();
        }
    };

    function onKeyPress(
        e: KeyboardEvent & {
            currentTarget: EventTarget & HTMLDivElement;
        }
    ) {
        // TODO: is this still needed with store approach?
        if (e && e.key == "Enter") {
            e.preventDefault();
            e.currentTarget.blur();
            onSaveMatrix();
            return;
        }
    }

    const todo = () => {

    };
</script>

<div class="row py-1 px-0 gx-0">
    <div class="d-flex">
        <div class="svg-icon-sm svg-icon-grey pe-1 fs-tool {$visible ? '' : 'low-opacity'}">
            <MatrixIcon />
        </div>
        <div
            class="mb-0  fs-tool {$visible ? '' : 'low-opacity'}"
            on:focusout={() => onSaveMatrix()}
            on:keypress={(e) => { return onKeyPress(e); }}
            contenteditable="true"
            bind:innerHTML={matrixName}></div>
        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1 ms-auto"
            on:click={async () => await onEditAsync()} on:keypress={() => todo()}>
            <i class="fe fe-edit" />
        </div>
        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1"
            on:click={async () => await onCopyAsync()} on:keypress={() => todo()}>
            <i class="fe fe-copy" />
        </div>
        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1 {$visible ? '' : 'low-opacity'}"
            on:click={() => {
                $visible = !$visible;
            }} on:keypress={() => todo()}>
            {#if $visible}
                <i class="fe fe-eye" />
            {:else}
                <i class="fe fe-eye-off" />
            {/if}
        </div>

        <div
            class="btn badge badge-rounded-circle badge-success-soft ms-1 {$visible ? '' : 'low-opacity'}"
            on:click={() => remove()} on:keypress={() => todo()}>
            <i class="fe fe-trash-2" />
        </div>
    </div>
</div>

{#each $assignmentRows as assignmentRow, j}
    <MatrixAssignmentRow bind:manager={assignmentRow} />
{/each}

<style>
    .low-opacity {
        opacity: 0.25;
    }
</style>
